export const TAX_RETURN_PURPOSE = 'TAX_RETURN';
export const REIMBURSEMENT_PURPOSE = 'REIMBURSEMENT';
